'use strict';

var baseClientSideValidation = require('base/components/clientSideValidation');
var Cleave = require('cleave.js').default;

var cleaveUSPhoneConfig = {
    numericOnly: true,
    blocks: [0, 3, 0, 3, 4],
    delimiters: ['(', ')', ' ', '-'],
    delimiterLazyShow: true
};

var zipUSConfig = {
    maxlength: 10,
    minlength: 5
};

var phoneUSConfig = {
    maxlength: 15,
    minlength: 10
};

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
    var valid = true;
    if (this.checkValidity) {
        try {
            if (!this.checkValidity()) {
                valid = false;
            }
        } catch (err) {
            valid = false;
        }
    }
    if (!valid) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
        $(this).find('input, select').each(function () {
            try {
                if (!this.validity.valid) {
                    $(this).trigger('invalid', this.validity);
                }
            } catch (validityErr) {
                $(this).trigger('invalid', this.validity);
            }
        });

        $(this).trigger('error:scrollToError');
    }
    return valid;
}

module.exports = $.extend(baseClientSideValidation, {
    init: function () {
        $(document).on('change', '.js-country-validation', function () {
            let $form = $(this).parents('.js-form-validation');
            let $zipCodeField = $('.js-zip-validation', $form);
            var $phoneField = $('.js-phone-validation', $form);
            // Fix - shipping country change not triggering globale pop up for guest user
            if ($phoneField.length < 1) {
                $phoneField = $('.js-phone-validation');
            }

            $phoneField.val('');
            $zipCodeField.val('');

            if ($(this).val() !== 'US') {
                $zipCodeField.attr({
                    maxlength: 10,
                    minlength: 1
                });

                $phoneField.attr({
                    maxlength: 15,
                    minlength: 10
                });

                let cleave = $phoneField.data('cleave');
                if (cleave && cleave.destroy) {
                    cleave.destroy();
                }
            } else {
                $zipCodeField.attr(zipUSConfig);
                $phoneField.attr(phoneUSConfig);
                $phoneField.data('cleave', new Cleave($phoneField[0], cleaveUSPhoneConfig));
            }
        });
    },

    /**
     * Scroll to and focus the first form error. Requires form attribute 'novalidate' to prevent
     * browsers own API blocking submit call.
     * Supports disabling it by adding the class `js-disable-error-scrolling` on the form.
     * Supports forms inside modals.
     * If error is a back-end injected error and not on a field, focuses the alert summary at top.
     */
    scrollToError: function () {
        $('form[novalidate]:not(.js-disable-error-scrolling)').on('error:scrollToError', function () {
            var $this = $(this);
            var $formModalParent = $this.parents('.modal');
            var isModal = $formModalParent.length > 0;
            var $scrollingElement = isModal ? $formModalParent : $('html, body');
            var modalPosition = isModal ? $formModalParent.offset().top - $formModalParent.scrollTop() : 0;
            var headerSpacing = isModal ? 0 : 100;
            var $firstInvalid = $this.find('.is-invalid').first();
            var $errorAlert = $this.children('.alert-danger[role="alert"]').first();
            var position = $firstInvalid.length
                ? ($firstInvalid.parent().offset().top - modalPosition) - headerSpacing
                : 0;

            $scrollingElement.animate({
                scrollTop: position
            }, 500);

            if ($firstInvalid.length) {
                $firstInvalid.focus();
            } else if ($errorAlert.length) {
                $errorAlert.attr('tabindex', '-1').focus();
            }
        });
    },

    invalid: function () {
        $('form input, form select, form textarea').on('invalid', function (e) {
            e.preventDefault();
            this.setCustomValidity('');
            if (!this.validity.valid) {
                var validationMessage = this.validationMessage;
                $(this).addClass('is-invalid').attr('aria-invalid', 'true');
                if (this.validity.typeMismatch && this.type === 'email' && $(this).data('email-error')) {
                    validationMessage = $(this).data('email-error');
                }
                if (this.validity.patternMismatch && $(this).data('pattern-mismatch')) {
                    validationMessage = $(this).data('pattern-mismatch');
                }
                if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if ((this.validity.tooLong || this.validity.tooShort)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if (this.validity.valueMissing && $(this).data('missing-error')) {
                    validationMessage = $(this).data('missing-error');
                }
                $(this).parents('.form-group').find('.invalid-feedback')
                    .text(validationMessage);
            }
        });
    },

    submit: function () {
        $('form').on('submit', function (e) {
            return validateForm.call(this, e);
        });
    },

    /**
     * Clears the validation errors of an invalidated form element after a change occurs
     */
    clearErrorsOnChange: function () {
        $(':input, .form-control').on('change input', function () {
            if ($(this).hasClass('is-invalid')) {
                $(this).removeClass('is-invalid').removeAttr('aria-invalid');
                $(this).parents('.form-group').find('.invalid-feedback').empty();
            }
        });
    },

    /**
     * Methods below inits Cleave JS (https://nosir.github.io/cleave.js/) global input formats.
     * Exception is the credit card fields that come OOTB at components/cleave.js and we don't need to rewrite here.
     */
    initPhoneFormat: function () {
        $('.js-phone-format').toArray().forEach(function (fieldElement) {
            let $form = $(fieldElement).parents('form');

            // Only load cleave for US phone field
            if ($form.find('.js-country-validation').length && $form.find('.js-country-validation').val() === 'US') {
                $(fieldElement).data('cleave', new Cleave(fieldElement, cleaveUSPhoneConfig));
            }
        });
        $('.group-order').toArray().forEach(function (fieldElement) {
            $(fieldElement).data('cleave', new Cleave(fieldElement, cleaveUSPhoneConfig));
        });
    },

    initMultiQTYFields: function () {
        $('.js-shop-multi-qty').toArray().forEach(function (fieldElement) {
            new Cleave(fieldElement, { // eslint-disable-line no-new
                numericOnly: true,
                blocks: [3]
            });
        });
    },

    limitNumericField: function () {
        $('.js-numeric-field-max-length').toArray().forEach(function (fieldElement) {
            if (fieldElement.hasAttribute('maxlength')) {
                new Cleave(fieldElement, { // eslint-disable-line no-new
                    numericOnly: true,
                    blocks: [Number(fieldElement.getAttribute('maxlength'))]
                });
            }
        });
    },

    shopMultiQtyFields: function () {
        $('.js-shop-multi-qty').toArray().forEach(function (fieldElement) {
            new Cleave(fieldElement, { // eslint-disable-line no-new
                numeral: true,
                blocks: [3],
                numeralDecimalScale: 0,
                stripLeadingZeroes: true,
                delimiterLazyShow: true,
                numeralPositiveOnly: true
            });
        });
    }
});
